import { forwardRef } from 'react'
import classNames from 'classnames'
import { useTabsContext } from './context'
import type { CommonProps } from '../@types/common'
import type { TabsValue } from './context'
import type { ReactNode } from 'react'

export interface TabContentProps extends CommonProps {
    children?: ReactNode
    value?: TabsValue
}

const TabContent = forwardRef<HTMLDivElement, TabContentProps>((props, ref) => {
    const { value, className, children, ...rest } = props

    const { value: currentValue } = useTabsContext()

    const active = currentValue === value

    const tabContentClass = classNames(
        'tab-content',
        active && 'tab-content-active',
        className
    )

    return (
        <div ref={ref} className={tabContentClass} role="tabpanel" {...rest}>
            {children}
        </div>
    )
})

TabContent.displayName = 'TabContent'

export default TabContent 